/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseField } from './DatabaseField';
import {
    DatabaseFieldFromJSON,
    DatabaseFieldFromJSONTyped,
    DatabaseFieldToJSON,
} from './DatabaseField';
import type { DatabaseFieldPreviewOptions } from './DatabaseFieldPreviewOptions';
import {
    DatabaseFieldPreviewOptionsFromJSON,
    DatabaseFieldPreviewOptionsFromJSONTyped,
    DatabaseFieldPreviewOptionsToJSON,
} from './DatabaseFieldPreviewOptions';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';
import type { DatabasePercentageFieldLook } from './DatabasePercentageFieldLook';
import {
    DatabasePercentageFieldLookFromJSON,
    DatabasePercentageFieldLookFromJSONTyped,
    DatabasePercentageFieldLookToJSON,
} from './DatabasePercentageFieldLook';

/**
 * 
 * @export
 * @interface DatabasePercentageField
 */
export interface DatabasePercentageField extends DatabaseField {
    /**
     * 
     * @type {DatabasePercentageFieldLook}
     * @memberof DatabasePercentageField
     */
    type?: DatabasePercentageFieldLook;
}

/**
 * Check if a given object implements the DatabasePercentageField interface.
 */
export function instanceOfDatabasePercentageField(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabasePercentageFieldFromJSON(json: any): DatabasePercentageField {
    return DatabasePercentageFieldFromJSONTyped(json, false);
}

export function DatabasePercentageFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabasePercentageField {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...DatabaseFieldFromJSONTyped(json, ignoreDiscriminator),
        'type': !exists(json, 'type') ? undefined : DatabasePercentageFieldLookFromJSON(json['type']),
    };
}

export function DatabasePercentageFieldToJSON(value?: DatabasePercentageField | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...DatabaseFieldToJSON(value),
        'type': DatabasePercentageFieldLookToJSON(value.type),
    };
}

